const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const isOwner = require('module/viewer/helpers/is_owner')
const isLoggedIn = require('module/viewer/helpers/is_logged_in')
const SvgInline = require('react-svg-inline').default
const LogoSvg = require('!!raw-loader!images/logos/logo.svg')
const log = require('log').create('nav logo'); // eslint-disable-line


function getLogoHref(props, context) {
    const { link_logo, logo_href } = props

    if (! link_logo) return

    // override this logic by passing in props.logo_href
    if (logo_href) return logo_href

    const { viewer, page } = context

    // link to homepage for anonymous viewers
    if (! isLoggedIn(viewer)) return '/'

    if (isOwner(viewer, page)) {
        // don't link logo if already on their own page
        return
    }

    return `/${viewer.user_name}`
}

function NavLogo(props, context) {
    const { render_logo } = props
    if (! render_logo) return null

    const href = getLogoHref(props, context)

    const component = href ? 'a' : 'span'

    const className = classNames('logo', 'glyph-ellipsis')

    return (
        <SvgInline
            component={component}
            href={href}
            className={className}
            onClick={props.toggleMobileNav}
            svg={LogoSvg}
            />
    )
}

NavLogo.contextTypes = {
    page: PropTypes.object,
    viewer: PropTypes.object,
}
NavLogo.propTypes = {
    render_logo: PropTypes.bool,
    link_logo: PropTypes.bool,
    toggleMobileNav: PropTypes.func,
}
NavLogo.defaultProps = {
    render_logo: true,
    link_logo: true,
}

module.exports = NavLogo
